import axios from "axios";
import { useAuthStore } from "../store/useAuthStore";

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:3000/api",
  headers: {
    "Content-Type": "application/json",
  },
});

/** Headers must be strings — use JSON.stringify (objects stringify to `"[object Object]"` and break the API). */
function webDeviceInfoHeader(): string {
  return JSON.stringify({
    platform: "WEB",
    userAgent:
      typeof navigator !== "undefined" ? navigator.userAgent : undefined,
  });
}

axiosInstance.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["device-info"] = webDeviceInfoHeader();
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      useAuthStore.getState().logout();
      const onLoginRoute = window.location.pathname.startsWith("/login");
      if (!onLoginRoute) {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
